var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg230(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#E6E7E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.7464,
    y: 48,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#E6E7E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3923,
    y: 50.0837,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(60 23.3923 50.0837)",
    fill: "#E6E7E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0503,
    y: 51.8661,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(-60 13.0503 51.8661)",
    fill: "#E6E7E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3184,
    y: 50,
    width: 1.39829,
    height: 8.38972,
    rx: 0.699144,
    fill: "#E6E7E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2657,
    y: 51.4568,
    width: 1.39829,
    height: 8.38972,
    rx: 0.699144,
    transform: "rotate(60 32.2657 51.4568)",
    fill: "#E6E7E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0352,
    y: 52.7029,
    width: 1.39829,
    height: 8.38972,
    rx: 0.699144,
    transform: "rotate(-60 25.0352 52.7029)",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 58H42V57.9976C42.1316 57.9976 42.262 58.0235 42.3836 58.0739C42.5052 58.1243 42.6157 58.1981 42.7088 58.2912C42.8019 58.3843 42.8757 58.4948 42.9261 58.6164C42.9765 58.738 43.0024 58.8684 43.0024 59C43.0024 59.1316 42.9765 59.262 42.9261 59.3836C42.8757 59.5052 42.8019 59.6157 42.7088 59.7088C42.6157 59.8019 42.5052 59.8757 42.3836 59.9261C42.262 59.9765 42.1316 60.0024 42 60.0024L42 62C42.394 62 42.7841 61.9224 43.148 61.7716C43.512 61.6209 43.8427 61.3999 44.1213 61.1213C44.3999 60.8427 44.6209 60.512 44.7716 60.1481C44.9224 59.7841 45 59.394 45 59C45 58.606 44.9224 58.2159 44.7716 57.8519C44.6209 57.488 44.3999 57.1573 44.1213 56.8787C43.8427 56.6001 43.512 56.3791 43.1481 56.2284C42.7841 56.0776 42.394 56 42 56H34V58ZM34 55H48V54.9976C48.1316 54.9976 48.262 55.0235 48.3836 55.0739C48.5052 55.1243 48.6157 55.1981 48.7088 55.2912C48.8019 55.3843 48.8757 55.4948 48.9261 55.6164C48.9765 55.738 49.0024 55.8684 49.0024 56C49.0024 56.1316 48.9765 56.262 48.9261 56.3836C48.8757 56.5052 48.8019 56.6157 48.7088 56.7088C48.6157 56.8019 48.5052 56.8757 48.3836 56.9261C48.262 56.9765 48.1316 57.0024 48 57.0024L48 59C48.394 59 48.7841 58.9224 49.1481 58.7716C49.512 58.6209 49.8427 58.3999 50.1213 58.1213C50.3999 57.8427 50.6209 57.512 50.7716 57.1481C50.9224 56.7841 51 56.394 51 56C51 55.606 50.9224 55.2159 50.7716 54.8519C50.6209 54.488 50.3999 54.1573 50.1213 53.8787C49.8427 53.6001 49.512 53.3791 49.1481 53.2284C48.7841 53.0776 48.394 53 48 53H34V55ZM34 52H44C44.394 52 44.7841 51.9224 45.1481 51.7716C45.512 51.6209 45.8427 51.3999 46.1213 51.1213C46.3999 50.8427 46.6209 50.512 46.7716 50.148C46.9224 49.7841 47 49.394 47 49C47 48.606 46.9224 48.2159 46.7716 47.8519C46.6209 47.488 46.3999 47.1573 46.1213 46.8787C45.8427 46.6001 45.512 46.3791 45.1481 46.2284C44.7841 46.0776 44.394 46 44 46L44 47.9976C44.1316 47.9976 44.262 48.0235 44.3836 48.0739C44.5052 48.1243 44.6157 48.1981 44.7088 48.2912C44.8019 48.3843 44.8757 48.4948 44.9261 48.6164C44.9765 48.738 45.0024 48.8684 45.0024 49C45.0024 49.1316 44.9765 49.262 44.9261 49.3836C44.8757 49.5052 44.8019 49.6157 44.7088 49.7088C44.6157 49.8019 44.5052 49.8757 44.3836 49.9261C44.262 49.9765 44.1316 50.0024 44 50.0024V50H34V52Z",
    fill: "#E6E7E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg230);
export default __webpack_public_path__ + "static/media/230.d50559f5cd91b7ef373283a3baeb10d2.svg";
export { ForwardRef as ReactComponent };